import { render, staticRenderFns } from "./Form51.vue?vue&type=template&id=2c0b014a&scoped=true"
import script from "./Form51.vue?vue&type=script&lang=ts"
export * from "./Form51.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=2c0b014a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b014a",
  null
  
)

export default component.exports